import { Component, OnInit, Input } from '@angular/core';
import { SmartLabelService } from '../smart-label.service';
import { PageService } from '../../../services/page.service';
import { AppService } from '../../../services/app.service';
@Component({
  selector: 'smart-label-otc-drug',
  templateUrl: './smart-label-otc-drug.component.html',
  styleUrls: ['./smart-label-otc-drug.component.scss']
})
export class SmartLabelOtcDrugComponent implements OnInit {

  @Input() config;
  @Input() smartLabelData;
  @Input() entityInformation;

  pageAlias = '';

  //CONTROL CONFIGs
  headerConfig: any;
  productHeaderConfig: any;
  tabConfig: any;
  footer1Config: any;
  footer2Config: any;
  footerLinksConfig: any;
  disclosureConfig: any;
  ingredientsConfig: any;
  drugFactsListConfig: any;
  socialLinksConfig: any;
  informationAccuracyConfig: any;

  constructor(
    private smartLabelService: SmartLabelService,
    private pageService: PageService,
    private appService: AppService) { }

  /**
   * [OTC_DRUG template template 1st page setup]
   * @author NeilC
   * @task QLIKTAG-3121
   * @return []
   */
  ngOnInit() {

    this.pageAlias = this.pageService.pageAlias;

    // console.log('A')
    // console.log('smartLabelData', JSON.parse(JSON.stringify(this.smartLabelService.smartLabelData)))

    this.smartLabelService.smartLabelData = this.smartLabelData; //this.appService.listCodeTranslate(this.smartLabelData);

    // console.log('B')
    // console.log('smartLabelData',   JSON.parse(JSON.stringify(this.smartLabelService.smartLabelData)))


    this.smartLabelService.smartLabelConfig = this.config;

    this.headerConfig = this.getHeaderConfig();
    this.productHeaderConfig = this.smartLabelService.getProductHeaderConfig();
    this.disclosureConfig = this.smartLabelService.getDisclosureLevelConfig(this.smartLabelService.nonfoodIngredientInformationPath);
    this.ingredientsConfig = this.getIngredientsConfig();
    this.drugFactsListConfig = this.getDrugFactsListConfig();
    //console.log(this.drugFactsListConfig);
    this.tabConfig = this.getTabConfig();



    if (this.config.hasOwnProperty('footer1')) {
      this.footer1Config = this.smartLabelService.getFooterConfig(1);
    }

    if (this.config.hasOwnProperty('footer2')) {
      this.footer2Config = this.smartLabelService.getFooterConfig(2);
    }

    this.footerLinksConfig = this.smartLabelService.getFooterLinksConfig();

    this.socialLinksConfig = this.smartLabelService.getSocialLinksConfig();
    this.informationAccuracyConfig = this.smartLabelService.getInformationAccuracyConfig();
  }

  /**
   * [Smartlabel header]
   * @author NeilC
   * @task QLIKTAG-3121
   * @return [header control configuration]
   */
  getHeaderConfig() {
    return {
      "ctrlName": "header",
      "config": {
        "sticky": true,
        "isBackButtonVisible": false,
        "isContentHeader": true,
        "class": 'smartlabel-header'
      }
    }
  }


  /**
   * [smartlabel 5 tabs configuration]
   * @author NeilC
   * @task QLIKTAG-3121
   * @return [tab control ]
   */
  getTabConfig() {
    return {
      "ctrlName": "tabs",
      "config": {
        "class": 'smartlabel-tabs',
        "value": this.smartLabelService.getTabName(0), //drug-facts
        "layout": 'icon-top',
        "scrollable": false,
        "tabs": 5,
        "sticky": true,
        "gridFixed": true
      },
      "controls": [
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(0), //drug-facts
            "title": this.smartLabelService.getTabTitle(0), //Drug Facts
            "icon": this.smartLabelService.getTabIcon(0),//['fas', 'search'],
            "show": true
          },
          "controls": [
            (this.drugFactsListConfig ? [this.drugFactsListConfig] : []),
            (this.disclosureConfig ? [this.disclosureConfig] : []),
            ...(this.ingredientsConfig ? this.ingredientsConfig : []),


          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(1),//'health-safety-and-environment',
            "title": this.smartLabelService.getTabTitle(1),//'Health, Safety & Environment',
            "icon": this.smartLabelService.getTabIcon(1),//['fas', 'exclamation-triangle'],
            "show": true
          },
          "controls": [
            this.tab2Config()
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(2),//'usage-and-handling',
            "title": this.smartLabelService.getTabTitle(2),//'Usage & Handling',
            "icon": this.smartLabelService.getTabIcon(2),//['far', 'hand-point-up'],
            "show": true
          },
          "controls": [
            // ...(this.usageAndHandlingConfig ? [this.usageAndHandlingConfig] : [])
            this.tab3Config()
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(3),//'feature-and-benefits',
            "title": this.smartLabelService.getTabTitle(3),//'Features & Benefits',
            "icon": this.smartLabelService.getTabIcon(3),//['fas', 'info-circle'],
            "show": true
          },
          "controls": [
            this.tab4Config()
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(4),//'company-brand-and-sustainability',
            "title": this.smartLabelService.getTabTitle(4),//'Company, Brand & Sustainability',
            "icon": this.smartLabelService.getTabIcon(4),//['fas', 'external-link-square-alt'],
            "show": true
          },
          "controls": [
            //  this.getContactTabsConfig(this.config),
            //  this.externalLinksConfig
            this.smartLabelService.getContactTabsConfig(),
            this.smartLabelService.getExternalLinksConfig(this.config)

          ]
        }

      ]
    }
  }
  /**
   * tab-4 Features and Benefits
   * @author Radhika Agnihotri
   * @task QLIKTAG-3202
   */
  tab4Config() {
    //console.log("OTC-drug tab4config ")
    let listConfig;
    let item;

    listConfig = {
      "ctrlName": "list",
      "title": "Features & Benefits",
      "config": {
        "class": "smartlabel-list",
      },
      "controls": []
    };

    if (this.smartLabelService.getAboutProductPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'Features & Benefits',
          "url": { "url": `p/${this.pageAlias}?detail=about-product`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    if (this.smartLabelService.getCertificationsList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": "Certifications",
          "url": { "url": `p/${this.pageAlias}?detail=certifications`, "type": "detail" }
        }
      }

      listConfig.controls.push(item);
    }

    if (this.smartLabelService.getGeneralInfoPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": "General Information",
          "url": { "url": `p/${this.pageAlias}?detail=general-information`, "type": "detail" }
        }
      };

      listConfig.controls.push(item);
    }
    //console.log("listconfig", listConfig)
    return listConfig;

  }

  /**
   * TAB-2 Health & Safety
   * @author Radhika Agnihotri
   * @task QLIKTAG-3199
   */
  tab2Config() {
    //console.log("otc-drug tab2Config")
    let listConfig;
    let item;

    listConfig = {
      "ctrlName": "list",
      "title": "Health & Safety",
      "config": {
        "class": "smartlabel-list"
      },
      "controls": []
    }

    if (this.smartLabelService.getOtcAllergenPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'About Allergens',
          "url": { "url": `p/${this.pageAlias}?detail=about-allergens`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    if (this.smartLabelService.getStorageAndDisposalList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'About Expiration Dates',
          "url": { "url": `p/${this.pageAlias}?detail=about-expiration-dates`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    if (this.smartLabelService.getOtcHealthAndSafetyPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'Health, Safety & Other Advisories',
          "url": { "url": `p/${this.pageAlias}?detail=health-safety-and-other-advisories`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    return listConfig;
  }

  /**
  * tab-3 Usage and Handling
  * @author Lalitkumar Saindane
  * @task QLIKTAG-3200
  * @returns [tab3 listConfig]
  */
  tab3Config() {
    let listConfig;
    const usageInstructionsList = this.smartLabelService.getUsageInstructionsList();
    const storageInstructionsList = this.smartLabelService.getStorageInstructionsList();

    listConfig = {
      "ctrlName": "list",
      "title": "Usage and Handling",
      "config": {
        "class": "smartlabel-list",
      },
      "controls": []
    };

    if (usageInstructionsList) {
      listConfig.controls.push(usageInstructionsList);
    }

    if (storageInstructionsList) {
      listConfig.controls.push(storageInstructionsList);
    }

    if (listConfig.controls.length > 0) {
      return listConfig;
    } else {
      return false;
    }

  }


  /**
   * [Return ingredients from statement or module]
   * @author Neil
   * @return [description]
   */
  getIngredientsConfig() {
    //console.log(this.nonfoodIngredientInformationPath);

    let ingredientsList = [];
    let ingredientListConfig;
    let inactiveIngredientListConfig;

    let activeIngredientHeadingConfig;
    let inactiveIngredientHeadingConfig;

    ingredientsList = this.smartLabelService.getIngredientsByList(this.smartLabelService.nonfoodIngredientInformationPath + '.nonfoodIngredient');

    //First check if ingredients have the isActive attribute
    let hasIsActive = (item) => {
      return item.hasOwnProperty('isActive');
    }

    if (ingredientsList.some(hasIsActive)) {
      //active ingredients
      ingredientListConfig = this.smartLabelService.ingredientListConfig(ingredientsList, 0, 0, 'active');

      if (ingredientListConfig.controls.length > 0) {

        activeIngredientHeadingConfig =
        {
          "ctrlName": "heading",
          "config": {
            "class": "smartlabel-ingredient-heading p-16 p-t-0 p-b-0",
            "text": "ACTIVE INGREDIENTS",
            "headingType": 2
          }
        }
      }


      //inactive ingredients
      inactiveIngredientListConfig = this.smartLabelService.ingredientListConfig(ingredientsList, 0, 0, 'inactive');


      if (inactiveIngredientListConfig.controls.length > 0) {

        inactiveIngredientHeadingConfig =
        {
          "ctrlName": "heading",
          "config": {
            "class": "smartlabel-ingredient-heading p-16 p-t-0 p-b-0",
            "text": "NON-ACTIVE INGREDIENTS",
            "headingType": 2
          }
        }
      }



    } else {
      ingredientListConfig = this.smartLabelService.ingredientListConfig(ingredientsList);
    }





    //console.log('COC', ingredientListConfig);

    //console.log(ingredientsList);
    if (ingredientsList.length > 0) {


      let result = [];

      if (activeIngredientHeadingConfig) {
        result.push(activeIngredientHeadingConfig)
      }

      if (ingredientListConfig) {
        result.push(ingredientListConfig)
      }

      if (inactiveIngredientHeadingConfig) {
        result.push(inactiveIngredientHeadingConfig)
      }

      if (inactiveIngredientListConfig) {
        result.push(inactiveIngredientListConfig)
      }

      return result;


    } else {
      //NOTE: use language listener

      ingredientsList = [...this.smartLabelService.getIngredientsByStatement(this.smartLabelService.nonfoodIngredientInformationPath + '.nonfoodIngredientStatement')];
      let list: any;
      let controls = [];
      //console.log('ingredientsList', ingredientsList);
      if (ingredientsList.length > 0) {
        list = {
          "ctrlName": "list",
          "title": "Ingredients List",
          "config": {
            "class": "smartlabel-list"
          },
          "controls": []
        }



        for (const ingredient of ingredientsList) {
          controls.push(
            {
              "ctrlName": "list-item",
              "config": {
                "label": ingredient
              }
            },
          )
        }



        list.controls = [...controls];


      }

      return [list];

    }

  }

  /**
   * [List configuration for link to drug facts image]
   * @author NeilC
   * @task QLIKTAG-3197
   * @return [list config]
   */
  getDrugFactsListConfig() {
    if (this.smartLabelService.getDrugFactsPanelPageLayout()) {
      return {
        "ctrlName": "list",
        "title": "Drug Facts",
        "config": {
          "class": "smartlabel-list drug-facts m-l-16 m-r-16"
        },
        "controls": [
          {
            "ctrlName": "list-item",
            "config": {
              "label": "Drug Facts Panel",
              "url": { "url": `p/${this.pageAlias}?detail=drug-facts`, "type": "detail" }
            }
          }
        ]
      }
    } else {
      return false;
    }

  }
}
